import { ProjectMilestoneModel } from '../../../../domain/projectMilestones/projectMilestoneModel';
import NumberField from '../../../shared/components/forms/NumberField';
import TextField from '../../../shared/components/forms/TextField';

interface Props {
    projectMilestone: ProjectMilestoneModel;
    onChange: (
        name: string,
        value: string | boolean | number[] | number | undefined
    ) => void;
}

export default function MilestoneDetailSection({
    projectMilestone,
    onChange: handleInputChange,
}: Props) {
    return (
        <>
            <h5 className='mb-3'>Nueva Fase - Hito</h5>
            <div className='col-5'>
                <TextField
                    label='Nombre del Hito'
                    name={'name'}
                    onChange={handleInputChange}
                    required={false}
                    value={projectMilestone.name}
                />
            </div>
            <div className='col-5'>
                <TextField
                    label='Tipo de Proyecto'
                    name={'typeProject'}
                    onChange={handleInputChange}
                    required={false}
                    value={projectMilestone.typeProject}
                />
            </div>
            <div className='col-2'>
                <NumberField
                    label='Ordinalidad'
                    name='ordinality'
                    onChange={handleInputChange}
                    required={true}
                    value={projectMilestone.ordinality}
                    key='ordinality'
                />
            </div>
        </>
    );
}
